import { Component, OnInit } from '@angular/core';
import { AdminServicesService } from '../admin-services.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-whislists-admin',
  templateUrl: './whislists-admin.component.html',
  styleUrls: ['./whislists-admin.component.css']
})
export class WhislistsAdminComponent implements OnInit {

  public username: string;
  public wishlist_get_id: any;
  wishlist_input_field: any;
  constructor(public admin: AdminServicesService,
    public toastr: ToastrService,
    public router: Router) { }

  ngOnInit(): void {
    this.admin.wishlist().subscribe((res: any) => {
      if (res.code === 200) {
        this.wishlist_get_id = res.data[0].ip_whitelist;
        this.wishlist_input_field = res.data[0].ip_address;
      }
    });
  }

  submit() {
    if (!this.wishlist_input_field) {
      return this.toastr.error("Empty Field");
    }
    else {
      let obj = {
        "id": this.wishlist_get_id,
        "ip": this.wishlist_input_field
      }
      this.admin.updateWishlist(obj).subscribe((res: any) => {
        if (res.code === 200) {
          this.toastr.success("Success");
        } else {
          this.toastr.error("error");
        }
      }, (err) => {
        console.log(err);
      });
    }
  }
}
